import React, { FC } from 'react';
import { TextField } from '@mui/material';

interface TextFilterComponentProps {
    value?: string,
    name?: string,
    label?: string,
    onChange?: (event: React.ChangeEvent<HTMLInputElement> | { target: { name: string, value: any } }) => void,
    onBlur?: () => void,
}

const TextFilterComponent: FC<TextFilterComponentProps> = (props) => {
    const { value, name, label, onChange, onBlur } = props;

    const handleKeyPress = (e: React.KeyboardEvent<HTMLDivElement>) => {
        if (e.key === 'Enter') {
            (e.target as HTMLInputElement).blur();
        }
    };

    return (
        <TextField
            data-testid="TextFilterComponent"
            value={value}
            onChange={onChange}
            onKeyDown={handleKeyPress}
            fullWidth
            key={name}
            onBlur={onBlur}
            name={name}
            label={label}
        />
    );
};

TextFilterComponent.defaultProps = {
    value: '',
    name: '',
    label: '',
    onChange: () => null,
    onBlur: () => null,
};

export default TextFilterComponent;
